$(document).ready(function() {
  var scrollTopValue= $(window).width() < 992 ? "180" : "160";

  $(function() {
    var link = $('#membershipStoreNav .nav-link');
    // Move to specific section when click on menu link
    link.on('click', function(e) {
      var target = $($(this).attr('href'));
      $('html, body').animate({
        scrollTop: target.offset().top - scrollTopValue
      }, 600);
      $(this).addClass('active');
      e.preventDefault();
    });

    // Run the scrNav when scroll
    $(window).on('scroll', function(){
      scrNav();
    });

    // scrNav function
    // Change active dot according to the active section in the window
    function scrNav() {
      var sTop = $(window).scrollTop();
      $('.store-category').each(function() {
        var id = $(this).attr('id'),
            offset = $(this).offset().top - 500,
            height = $(this).height();
        if(sTop >= offset && sTop < offset + height) {
          link.removeClass('active');
          $('#membershipStoreNav').find('[data-scroll="' + id + '"]').addClass('active');
        }
        if (sTop <= 500) {
          link.removeClass('active');
        }
      });
    }
    scrNav();
  });
});
